import { createFileRoute } from '@tanstack/react-router';
import { useLayoutEffect } from 'react';

import { AnalyticsSection } from '~/components/analytics-section.tsx';
import { AppFooter } from '~/components/footer.tsx';
import { Header } from '~/components/header.tsx';
import { HeroSection } from '~/components/hero-section.tsx';
import { MobileSection } from '~/components/mobile-section.tsx';
import { PricingSection } from '~/components/pricing-section.tsx';
import { WhySection } from '~/components/why-section.tsx';

export const Route = createFileRoute('/$pathLocale/')({
  component: RouteComponent,
});

function RouteComponent() {
  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('active');
        });
      },
      { threshold: 0.15 }
    );
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
  }, []);

  return (
    <>
      <Header />
      <HeroSection />
      <WhySection />
      <MobileSection />
      <AnalyticsSection />
      <PricingSection />
      <AppFooter />
    </>
  );
}
